import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "src/shared/hooks";
import { careersModel } from "src/entities/careers";

import { employments } from "../model/constants";

export const EmploymentsSelect: React.FC = () => {
  const dispatch = useAppDispatch();

  const { employmentType } = useAppSelector(
    careersModel.selectors.selectNewCareer,
  );

  const handleChange = (event: SelectChangeEvent) => {
    const selectedEmployment = event.target.value;

    dispatch(
      careersModel.actions.changeNewCareer({
        employmentType: selectedEmployment,
      }),
    );
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="demo-simple-select-label">Employment type</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={employmentType as unknown as string}
        label="Employment type"
        onChange={handleChange}
      >
        {Object.values(employments).map((employment) => (
          <MenuItem key={employment.value} value={employment.value}>
            {employment.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
